import React, { useEffect } from 'react';
import AnimatedBackground from '../components/AnimatedBackground';
import { GYM_INFO, SUPPLEMENTS } from '../mock';
import { ShoppingBag, Shield, Award, Truck } from 'lucide-react';

const Supplements = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <AnimatedBackground />

      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-4 uppercase">
            Premium <span className="text-[#39FF14]">Supplements</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8">
            100% authentic, lab-tested supplements from top brands. Fast delivery across Indore.
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-[#39FF14]" />
              <span className="text-gray-400 text-sm">FSSAI Certified</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="w-5 h-5 text-[#39FF14]" />
              <span className="text-gray-400 text-sm">Lab Tested</span>
            </div>
            <div className="flex items-center gap-2">
              <Truck className="w-5 h-5 text-[#39FF14]" />
              <span className="text-gray-400 text-sm">Fast Delivery</span>
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {SUPPLEMENTS.map((product) => (
            <div
              key={product.id}
              className="group bg-gradient-to-br from-[#1a1a1a] to-black p-6 rounded-2xl border border-[#39FF14]/20 hover:border-[#39FF14] transition-all duration-300 hover:scale-105"
            >
              {/* Product Image */}
              <div className="aspect-square mb-4 rounded-xl overflow-hidden bg-black/50 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Product Info */}
              <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
              <p className="text-sm text-gray-400 mb-4">{product.description}</p>

              {/* Benefits */}
              <ul className="space-y-2 mb-6">
                {product.benefits.map((benefit, idx) => (
                  <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
                    <span className="w-1.5 h-1.5 bg-[#39FF14] rounded-full mt-1.5 flex-shrink-0" />
                    {benefit}
                  </li>
                ))}
              </ul>

              {/* Price & CTA */}
              <div className="flex items-center justify-between pt-4 border-t border-[#39FF14]/20">
                <span className="text-3xl font-black text-[#39FF14]">₹{product.price}</span>
                <a
                  href={`${GYM_INFO.whatsappLink}?text=Hi, I want to order ${product.name} (₹${product.price})`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#39FF14] text-black font-bold text-sm uppercase rounded-full hover:scale-105 transition-transform"
                >
                  <ShoppingBag className="w-4 h-4" />
                  Order
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-gradient-to-br from-[#1a1a1a] to-black p-12 rounded-3xl border border-[#39FF14]/20">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4 uppercase">
            Need Help Choosing?
          </h2>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
            Not sure which supplement is right for you? Chat with our nutrition experts on WhatsApp for personalized recommendations.
          </p>
          <a
            href={`${GYM_INFO.whatsappLink}?text=Hi, I need help choosing the right supplements`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#39FF14] text-black font-bold text-lg uppercase rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-[#39FF14]/50 transition-all duration-300"
          >
            Chat with Expert
          </a>
        </div>
      </div>
    </div>
  );
};

export default Supplements;
